var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0.67,
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0.33,
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0,
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))));
};
export default SvgLoading;